/**
 * Refactored by mariushirjanu on 10/11/2020.
 */
import { Component, Input, Output, OnInit, EventEmitter, ViewEncapsulation } from '@angular/core';
import { util } from '../util';

@Component({
  selector: 'collapsible-pane',
  template: `    
    <h3 class="collapse-title" [ngClass]="{ 'not-clickable': !clickable }" *ngIf="title">
      <collapse-indicator class="collapse-indicator" [open]="!collapsed" [clickable]="clickable" [linkName]="title" (onChange)="onChangeCollapsed($event)"></collapse-indicator>
      <ng-content select=".collapsible-title-extra"></ng-content>
    </h3>
    
    <ng-template #content><ng-content></ng-content></ng-template>
    
    <ng-container *ngIf="!partialRender">
      <div class="collapse-pane" [collapse]="collapsed" [isAnimated]="animated">
        <div *ngTemplateOutlet="content" [hidden]="collapsed"></div>
      </div>  
    </ng-container>
    
    <ng-container *ngIf="partialRender">
      <div class="collapse-pane" [collapse]="collapsed" [isAnimated]="animated">
        <ng-container *ngIf="!collapsed">
          <div *ngTemplateOutlet="content"></div>  
        </ng-container>
      </div>
    </ng-container>
  `,
  encapsulation: ViewEncapsulation.None,
  styleUrls: [ 'collapsible-pane.scss' ]
})
export class CollapsiblePaneComponent implements OnInit {
  // bindings
  @Input() public collapsed:boolean;
  @Input() public title:string;
  @Input() public animated:boolean;
  @Input() public partialRender:boolean; // whether to display content completely in DOM within collapsible at once (first load) or based conditional state (when expanded)
  @Input() public clickable?:boolean; // false: do not allow pane to expand
  @Output() public onChange:EventEmitter<boolean> = new EventEmitter();

  constructor() {
    /***/
  }

  public ngOnInit():void {
    this.collapsed = util.isUndefined(this.collapsed)? true : this.collapsed; // set collapsed as default
    this.animated = util.isUndefined(this.animated)? true : this.animated; // set animated as default
    this.clickable = util.isUndefined(this.clickable)? true : this.clickable; // set clickable as default
  }

  public onChangeCollapsed(collapsed:boolean):void {
    this.collapsed = collapsed;
    this.onChange.emit(collapsed);
  }
}